// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-Table-Table-module__root--1nY1a"};